import React from 'react';

import DeleteIcon from '../../assets/icons/DeleteIcon';
import ExportIcon from '../../assets/icons/DownloadIcon';
import FileCopyIcon from '../../assets/icons/CopyIcon';
import UploadIcon from '../../assets/icons/UploadIcon';

import Button from '../shared/Button';
import Select from '../shared/Select';

const KitsFilters = (props) => {
  const {
    onAddKitClick,
    status,
    setStatus,
    statuses,
    onDelete,
    onUploadClick,
    onDuplicateClick,
    deletePermission,
    onExportClick,
    exportLoading,
  } = props;

  return (
    <div className='settings-cmp__filters--main'>
      <div className='settings-cmp__actions'>
        <Button
          text='Add Kit'
          type='submit'
          onClick={onAddKitClick}
        />

        <Button
          type='submit'
          width='60px'
          onClick={onUploadClick}
        >
          <UploadIcon color="#ffffff" />
        </Button>

        <Button
          type='icon'
          onClick={onDelete}
          disabled={!deletePermission}
        >
          <DeleteIcon />
        </Button>

        <Button
         type='icon'
         onClick={onDuplicateClick}
        >
          <FileCopyIcon />
        </Button>

        <Button
          type='icon'
          onClick={onExportClick}
          disabled={exportLoading}
          loading={exportLoading}
        >
          <ExportIcon />
        </Button>
      </div>

      <div className='settings-cmp__filters'>
        <Select
          value={status}
          onChange={setStatus}
          options={statuses}
          defaultLabel={`All Status (${statuses.length})`}
          width={200}
        />
      </div>
    </div>
  )
};

export default KitsFilters;
